// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1rm-y","search":"Settings_search__3r7dz","filter":"Settings_filter__2VVxi"};